import { removeDiacritics } from "./stringUtils";

export function stringNormalize(
  value: string,
  options: { preserveSpaces?: boolean } = {}
): string {
  if (typeof value !== "string") {
    return "";
  }

  const { preserveSpaces } = options;

  return [
    removeDuplicates,
    preserveSpaces ? removeExtraSymbolsPreserveSpaces : removeExtraSymbols
  ]
    .reduce((p, c) => c(p), removeDiacritics(value))
    .trim();
}

function removeExtraSymbols(value: string) {
  return value.replace(/[^a-zA-Z0-9]/g, "");
}

function removeExtraSymbolsPreserveSpaces(value: string) {
  return value.replace(/[^a-zA-Z0-9\s]/g, "");
}

function removeDuplicates(value: string): string {
  const result = [];

  const length = value.length;
  let previous = null;

  for (let i = 0; i < length; i += 1) {
    const current = value.charAt(i);

    if (current !== previous) {
      result.push(current);
    }

    previous = current;
  }

  return result.join("");
}
